export default "__VITE_PUBLIC_ASSET__5b025337__"